export enum CaptchaProviderSettings {
  Telerik = 1,
  Google = 2,
  Friendly = 3
}
